import { render, staticRenderFns } from "./CriterioCheckbox.vue?vue&type=template&id=4618889d"
import script from "./CriterioCheckbox.vue?vue&type=script&lang=js"
export * from "./CriterioCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CriterioCheckbox.vue?vue&type=style&index=0&id=4618889d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports